import { GALLERY } from "../../data/tavern";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mb-12 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[color:var(--pk-primary)]">
              ΓΚΑΛΕΡΙ
            </p>
            <h2 className="mt-3 font-display text-3xl font-black leading-tight tracking-tight text-[color:var(--pk-text)] sm:text-4xl md:text-5xl">
              Μια ματιά στην ταβέρνα μας
            </h2>
          </div>
          <p className="text-base text-[color:var(--pk-text-soft)] md:max-w-sm md:text-right">
            Φωτογραφίες από τα πιάτα, την αυλή και τις στιγμές που μας χαρίζετε
            εσείς καθημερινά.
          </p>
        </div>

        {/* Bento-style grid — 7 photos */}
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {GALLERY.map((img, idx) => {
            const layouts = [
              // 0 — big hero tile (spans 2 cols + 2 rows on md+)
              "col-span-2 row-span-2 aspect-square md:aspect-auto md:h-[480px]",
              // 1 — small square
              "aspect-square md:aspect-auto md:h-[232px]",
              // 2 — small square
              "aspect-square md:aspect-auto md:h-[232px]",
              // 3 — wide rectangle (spans 2 cols)
              "col-span-2 aspect-[2/1] md:col-span-2 md:aspect-auto md:h-[232px]",
              // 4 — small square
              "aspect-square md:aspect-auto md:h-[232px]",
              // 5 — small square
              "aspect-square md:aspect-auto md:h-[232px]",
              // 6 — wide rectangle (spans 2 cols)
              "col-span-2 aspect-[2/1] md:col-span-2 md:aspect-auto md:h-[232px]",
            ];
            return (
              <div
                key={idx}
                className={`gallery-tile lift ${layouts[idx] || "aspect-square"}`}
                data-testid={`gallery-tile-${idx}`}
              >
                <img
                  src={img.url}
                  alt={img.alt}
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
